import {FilterFieldsOptions} from '@ui/ui.module';

export type BaseSettings = {
  id:string;
  name:string;
  scope:'system'|'user';
  user:string;
}
export interface Settings<T> {
  id: string;
  scope: 'system' | 'user';
  name: string;
  value: T | T[];
}

export type SettingsClassName =
  'BeneOA' |
  'BeneS' |
  'BeneF' |
  'BeneD' |
  'BeneMI' |
  'DocumentoArc' |
  'DocumentoBib' |
  'Base' |
  'Collezione' |
  'OggettoCollezione';

export type ExportFileFormat = 'pdf' | 'csv';

export interface SystemLayout {
  fileFormat: ExportFileFormat;
  template: string;
  className: SettingsClassName;
  description: string;
}

export interface SystemSettings {
  fileFormats: ExportFileFormat[];
  layouts: SystemLayout[];
}

export interface UserSettings {
  value: any;
}

export interface SettingsState {
  system?: SystemSettings;
  user?: UserSettings[];
}

export interface SettingsFilter {
  scope?: 'system' | 'user';
  user?: string;
}

export const SettingsFilterMeta: FilterFieldsOptions<SettingsFilter> = {
  scope: {operator: 'equal'},
  user: {operator: 'equal', typeField: 'oid'},
};
